// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource';
import ElementUI from 'element-ui' //引入element-ui
// import Vuex from 'vuex'
import {
  message
} from './utils/resetMessage'

import {
  Loading
} from 'element-ui';
Vue.use(Loading.directive);

import axios from 'axios'
import dataV from '@jiaminghi/data-view'
// 引入echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

// 自定义组件
import Echart from './components/Echart/index.vue'
Vue.component('Echart', Echart)

// import Qs from 'qs'
//QS是axios库中带的，不需要npm安装
Vue.prototype.axios = axios;
// Vue.prototype.qs = Qs;

Vue.config.productionTip = false

import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/common.scss' // 引入全局样式
import '../theme/index.css'
import store from './store'

import '@/assets/js/drag.js' //引入拖曳组件
import {
  TITLE_ENV
} from '../config/prod.env.js'

/**
 * 导入exportFile函数并将其挂载到Vue原型上
 * 以便在所有Vue实例中可以直接使用$exportFile方法
 */
import { exportFile } from '@/components/exportfile.js'
Vue.prototype.$exportFile = exportFile;

Vue.prototype.$store = store
Vue.use(dataV)
Vue.use(VueResource);
Vue.use(ElementUI)
// Vue.use(Vuex)
Vue.prototype.$message = message;
//路由拦截
router.beforeEach((to, from, next) => {
  //console.log(to.query.token,to);
  if (to.query.token) {
    window.localStorage.setItem('token', decodeURIComponent(to.query.token))
    next({ path: '/home' })
  }
  if (to.matched.length === 0) { //匹配前往的路由不存在
    next({
      path: '/home',
    })
  }

  let loginSign = window.localStorage.getItem('token'); //获取公共权限请求头
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (loginSign) { //判断本地是否存在access_token
      next();
    } else {
      if (to.path === '/login') {
        next();
      } else {
        next({
          path: '/'
        })
      }
    }
  } else {
    next();
  }

  /*如果本地 存在 token 则 不允许直接跳转到 登录页面*/
  if (to.fullPath === "/login" || to.fullPath === '/') {
    //重定向到mysource页面
    if (loginSign) {
      next({
        path: '/home',
        // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    } else {
      next();
    }
  }
})


// 添加请求拦截器
// const Axios = axios.create();
axios.create({
  timeout: 10 * 1000
});
axios.interceptors.request.use(config => {
  // console.log(config);
  let token = window.localStorage.getItem('token'); //获取公共权限请求头
  if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.token = token;
  }
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})
// 添加响应拦截器
axios.interceptors.response.use(function (res) {
  // 对响应数据做点什么
  if (res.data.token && res.data.token !== "") {
    //覆盖localstorage中token
    localStorage.setItem("token", res.data.token);
  } else if (res.data.code === 100 || res.data.code === 101 || res.data.code === 102 || res.data.code === 103) {
    localStorage.removeItem('token');
    // localStorage.removeItem("userName"); //清除用户名
    setTimeout(() => {
      /* router.push({
              path: '/'
          }) */
      window.location.href = '/index/#/'

    }, 1000);

  }
  return res;
}, function (error) {
  // console.log(error);

  //超时处理 error.config是一个对象，包含上方create中设置的三个参数
  var config = error.config;
  //如果有响应内容，就直接返回错误信息，不再发送请求
  if (error.response && error.response.data) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }

  // __retryCount用来记录当前是第几次发送请求
  config.__retryCount = config.__retryCount || 0;
  // 如果当前发送的请求大于等于设置好的请求次数时，不再发送请求，返回最终的错误信息
  if (error.message === "Network Error") {
    //message为"Network Error"代表断网了
    return Promise.resolve({ data: { type: "warning", msg: "网络连接已断开，请检查网络", code: 0 } });
  } else if (error.message === "timeout of 10000ms exceeded") {
    //网太慢了，5秒内没有接收到数据，这里的5000ms对应上方timeout设置的值
    return Promise.resolve({ data: { type: "warning", msg: "请求超时，请检查网络", code: 0 } });
  } else {
    //除以上两种以外的所有错误，包括接口报错 400 500 之类的
    return Promise.reject(error)
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App,
    store
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js